import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { ErrorResponse, globalErrorResponse } from '../../../../store/notifications/actions';
import { changeReserveCopyAmount } from './apiChangeReserveCopyAmount';
import { invalidateReserveReportSummary } from '../reserve-list/useReserveReportSummary';
import { invalidateReserveReportProducts } from '../reserve-list/useReserveReportProducts';

export type CopyAmountChangeOptions = {
    productId: string;
    numCopies: number;
    command: string;
};

export function useCopyAmountChange(reserveListId: string) {
    const dispatch = useDispatch();

    return useMutation<boolean, ErrorResponse, CopyAmountChangeOptions>(
        (options: CopyAmountChangeOptions) => {
            if (isNaN(options.numCopies)) {
                return Promise.resolve(false);
            }
            return changeReserveCopyAmount(reserveListId, options);
        },
        {
            onSuccess: hasChanged => {
                if (hasChanged) {
                    invalidateReserveReportSummary(reserveListId).then();
                    invalidateReserveReportProducts(reserveListId).then();
                }
            },
            onError: error => {
                dispatch(globalErrorResponse(error));
            }
        }
    );
}
